<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="qrcode-box">
        <canvas id="qrCode"></canvas>
        <div class="tips">
          1、手机扫描二维码进入上传页，文档上传完成后点击打印按钮开始打印。打印完毕请及时取走资料
        </div>
        <div class="tips">
          2、安卓手机使用微信扫码可以从手机相册内选取一个文档，安卓手机使用浏览器扫码或苹果手机扫码可上传多个文档，确定上传后即可打印
        </div>
        <div class="tips-admin">注意:体积比较大的文件或者图片可能无法上传</div>
      </div>
      <div class="file-box">
        <!-- <div class="file-card" v-for="(item, idx) in  fileList" :key="idx">
          <div class="file-img ">{{ item.fileName }}</div>
          <div class="delt" @click="delt(idx)">×</div>
        </div> -->
        <div>
          <el-table :data="fileList" stripe style="width: 100%">
            <el-table-column prop="fileName" label="文件名"> </el-table-column>
            <el-table-column prop="name" label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-delete"
                  @click="delt(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
    <Back :print="print" @toPrintEve="toPrintEve(0)" />
  </div>
</template>
<script>
import QRCode from "qrcode";
import { v4 as uuidv4 } from "uuid";
// import lodop from "@/assets/js/doPrint.js"
import { Loading } from "element-ui";

export default {
  name: "",
  data() {
    return {
      //
      uuid: "",
      getTimer: null,
      fileList: [],
      print: "1",
      waitTime: 290,
      watiTimer: null,
      printTotal: 0,
      maskShow: false,
      loadingInstance: null,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
    };
  },
  created() {
    //
  },
  beforeDestroy() {
    // console.log('清除定时器');
    clearTimeout(this.getTimer);
    clearTimeout(this.watiTimer);
  },
  mounted() {
    //
    this.uuid = "";
    this.openQRCode();
    this.timeDown();
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
    this.checkPrintCurrent();
  },
  methods: {
    toPrintEve(idx) {
      if (this.printTotal <= 0) {
        this.messageToast("单人每天限制打印10张");
        return;
      }
      if (idx > this.fileList.length - 1) {
        return;
      }
      this.maskShow = true;
      setTimeout(() => {
        if (!this.loadingInstance) {
          this.loadingInstance = Loading.service({
            fullscreen: true,
            text: "正在打印...",
            target: document.querySelector("#loadDom"),
          });
          setTimeout(() => {
            this.loadingInstance.close();
          }, 16000);
        }
      }, 500);
      var content = this.fileList[idx];
      if (content.type == "pdf_url") {
        const formData = new FormData();
        formData.append("filePath", content.url);
        formData.append("upperBound", this.printTotal);
        this.$rqt.common_printFile(formData).then((res) => {
          console.log(res);
          var page = res.data;
          this.savePrintRecord(page); //保存打印页数
          this.printTotal = this.printTotal - page;
          if (this.printTotal <= 0) {
            this.messageToast("单人每天限制打印10张");
            return;
          }
          this.toPrintEve(idx + 1); //打印下一个文件
        });
        // this.$rqt.common_printFile({
        //   filePath: content.url,
        //   upperBound: this.printTotal
        // }).then(res => {
        //   console.log(res);
        // })

        // lodop.pdfPrint(content.url, this.printTotal, page => {
        //   // console.log('打印页数', page);
        //   this.savePrintRecord(page) //保存打印页数
        //   this.printTotal = this.printTotal - page
        //   if (this.printTotal <= 0) {
        //     this.messageToast('单人每天限制打印10张')
        //     return
        //   }
        // })
      }
      // this.toPrintEve(idx + 1) //打印下一个文件
    },
    messageToast(content) {
      this.$alert(content, "提示", {
        confirmButtonText: "确定",
      });
    },
    // 检查剩余打印次数
    checkPrintCurrent() {
      this.$rqt
        .print_getPrintLastNumber({
          idCard: this.idCard,
          type: "上传打印",
        })
        .then((res) => {
          this.printTotal = 10 - res.data;
          console.log("剩余打印次数", this.printTotal);
        });
    },
    // 保存打印记录
    savePrintRecord(count) {
      for (let index = 0; index < count; index++) {
        this.$rqt.print_save({
          type: "上传打印",
          fmac: this.fmac,
          name: this.name,
          phone: this.phone,
          idCard: this.idCard,
        });
      }
    },
    //
    openQRCode() {
      this.uuid = uuidv4().replaceAll("-", "");
      // this.uuid = '5e819a1babf047c0bed94a5e5205264f'
      setTimeout(() => {
        this.useqrcode();
        this.getUserFile();
      }, 500);
    },
    // 获取用户上传文件
    getUserFile() {
      this.$rqt
        .common_getRecord({
          key: this.uuid,
        })
        .then((res) => {
          if (res.data) {
            this.fileList = res.data;
            this.print = "2";
          } else {
            this.print = "1";
          }
          // else {
          this.getTimer = setTimeout(() => {
            this.getUserFile();
          }, 3500);
          // }
        });
    },
    // 删除
    delt(idx) {
      this.fileList.splice(idx, 1);
      this.$rqt.common_saveRecord({
        key: this.uuid,
        value: this.fileList,
      });
    },
    // 生成二维码
    useqrcode() {
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数   http://192.168.1.104:8080
      QRCode.toCanvas(
        canvas,
        `https://l.zwfwpt.cn/#/file?id=${this.uuid}&type=file`,
        // `http://192.168.1.103:8080//#/file?id=${this.uuid}&type=file`,
        function (error) {
          if (error) {
            console.error(error);
          } else {
            // console.log("success!");
          }
        }
      );
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 290;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  // width: 70%;
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  // margin: auto;
  background-color: #fff;
  position: relative;
  // overflow: scroll;
  display: flex;
  align-items: center;
}

.qrcode-box {
  width: 35%;
}

#qrCode {
  width: 60rem !important;
  height: 60rem !important;
  margin: auto !important;
  display: block !important;
}

.file-box {
  width: 65%;
  height: calc(100vh - 42rem - 40px);
  overflow-y: scroll;
  // display: flex;
  flex-wrap: wrap;
  background-color: rgba($color: #bbb6b6, $alpha: 0.1);
}

.file-box::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.file-card {
  position: relative;
  margin-bottom: 20px;
}

.delt {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 12rem;
  font-weight: bold;
}

.file-img {
  display: block;
  width: 100%;
  font-size: 4rem;
}

.tips {
  font-size: 4rem;
  margin-bottom: 10px;
}

.tips-admin {
  font-size: 5rem;
  color: #ff0000;
  font-weight: bold;
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background-color: red;
}

::v-deep .el-table th {
  border-color: rgb(152, 151, 151) !important;
}

::v-deep .el-table td {
  border-color: rgb(198, 196, 196) !important;
}

::v-deep .el-table--group,
::v-deep .el-table--border {
  border: 0.1px solid rgb(152, 151, 151) !important;
}
</style>